var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',[_c('div',{staticClass:"fill-height"},[_c('img',{attrs:{"alt":_vm.file.name,"width":"100%","src":_vm.url}})])])}
var staticRenderFns = []

export { render, staticRenderFns }